module.exports = __webpack_public_path__ + "img/AssaAbloy_guide_monteringsstolpe.1128d61f.jpg";